import React from 'react';
import FoundationHero from '../components/FoundationHero';
import FoundationSection from '../components/FoundationSection';

const Home = () => {
  return (
    <>
      <FoundationHero />
      <FoundationSection
        title="Nuestra Causa: Fortaleciendo Raíces"
        id="cause"
        imageSrc="/img4.jpg"
        imageAlt="Niños afrocolombianos sonriendo"
        imagePosition="left"
      >
        <p className="text-lg md:text-xl leading-relaxed mb-6">
          “Impulsar el desarrollo integral de las comunidades afrocolombianas, raizales y palenqueras en situación de vulnerabilidad, mediante la promoción de sus derechos, el fortalecimiento de sus capacidades productivas, y el acceso equitativo a oportunidades sociales, educativas y económicas.”
        </p>
        <p className="text-lg md:text-xl leading-relaxed">
          “Construimos futuro para las comunidades afrocolombianas: más oportunidades, más derechos, más dignidad.”
        </p>
      </FoundationSection>
    </>
  );
};

export default Home;